import { combineReducers, createReducer } from 'utils/redux'

import * as actions from './actions'

const results = createReducer(
  {},
  {
    [actions.fetchServiceDataSuccess.toString()]: ({
      draft,
      action: {
        payload: { queryConfig, response },
      },
    }) => {
      draft[JSON.stringify(queryConfig)] = response
    },
  }
)

const createQueryState = () => ({
  isPending: false,
  isFinished: true,
  lastUpdated: 0,
})

const handleQueryComplete = ({
  draft,
  action: {
    payload: { queryConfig },
  },
}) => {
  const key = JSON.stringify(queryConfig)
  draft[key] = {
    ...draft[key],
    isFinished: true,
    isPending: false,
    lastUpdated: Date.now(),
  }
}

const queries = createReducer(
  {},
  {
    [actions.fetchServiceData.toString()]: ({
      draft,
      action: {
        payload: { queryConfig },
      },
    }) => {
      draft[JSON.stringify(queryConfig)] = createQueryState()
    },

    [actions.fetchServiceDataPending.toString()]: ({
      draft,
      action: { payload },
    }) => {
      draft[JSON.stringify(payload)].isFinished = false
      draft[JSON.stringify(payload)].isPending = true
    },

    [actions.fetchServiceDataSuccess.toString()]: handleQueryComplete,
    [actions.fetchServiceDataFailed.toString()]: handleQueryComplete,
  }
)

export default combineReducers({
  queries,
  results,
})
